var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActiveGraphIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 28,
    viewBox: "0 0 30 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5033 3.81104H5.69046C4.87175 3.81104 4.17584 4.47215 4.17584 5.24992V16.411C3.11151 17.2277 2.45654 18.4333 2.45654 19.7944C2.45654 22.2055 4.50333 24.1888 7.08227 24.1888C8.76064 24.1888 10.2343 23.3333 11.053 22.0499H25.5443C26.363 22.0499 27.0589 21.3888 27.0589 20.611V5.24992C27.0179 4.47215 26.322 3.81104 25.5033 3.81104Z",
    stroke: "white",
    strokeWidth: 0.986842,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.46826 17.5779V20.3001H9.25189",
    stroke: "white",
    strokeWidth: 0.986842,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8889 12.25H21.3684L18.4211 17.1111L15.9649 8.75L13.5088 14.4667L12.4854 12.25H6.26318",
    stroke: "white",
    strokeWidth: 0.986842,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveGraphIcon);
export default __webpack_public_path__ + "static/media/Active_Graph_Icon.5932a1424065224cfea30e80bc3c4347.svg";
export { ForwardRef as ReactComponent };